$(document).ready(function() {

  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });


  /*Dropdown Top Menu*/
  $('.dropdown').click(function () {
    $(this).attr('tabindex', 1).focus();
    $(this).toggleClass('active');
    $(this).find('.dropdown-menu').slideToggle(300);
  });
  $('.dropdown').focusout(function () {
    $(this).removeClass('active');
    $(this).find('.dropdown-menu').slideUp(300);
  });
  $('.dropdown .dropdown-menu li').click(function () {
    $(this).parents('.dropdown').find('span').text($(this).text());
    $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
  });

  // let Demo2 = () => {
  //   console.log("ES6 is Running!");
  // }
  // Demo2();


  var HeaderHeight = $('.Header').outerHeight()-4;
  $('main').css('padding-top', HeaderHeight);
  // console.log("Header_Height", HeaderHeight);

  function SubscribeBtnValue(){
    var subscribeBtnVal = $('.es_subscription_form_submit').val('');
    // console.log('subscribeBtnVal', SubscribeBtnValue);
  }
  SubscribeBtnValue();

  /*Scroll to top when arrow up clicked BEGIN*/
  var btn = $('#button');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });
  /*Scroll to top when arrow up clicked END*/

  $('#ProductIsotope').imagesLoaded().progress( function() {
    $('#ProductIsotope').isotope({
      layoutMode: 'masonry'
    });
  });

  $(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
  $("ul.tabs li").click(function() {
    
    $(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $("#"+activeTab).fadeIn();    
    
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
    /*$(".tabs").css("margin-top", function(){ 
       return ($(".tab_container").outerHeight() - $(".tabs").outerHeight() ) / 2;
    });*/
  });
  $(".tab_container").css("min-height", function(){ 
    return $(".tabs").outerHeight() + 50;
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    
    $(".tab_content").hide();
    var d_activeTab = $(this).attr("rel"); 
    $("#"+d_activeTab).fadeIn();
  
    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  });

  //Home Tabs
  $('.TabsWrapper > a').click(function(e){
    e.preventDefault();
    var tab_id = $(this).attr('href');
    $('.TabsWrapper > a').removeClass('Active');
    $('.TabContents').removeClass('Active');
    $(this).addClass('Active');
    $(tab_id).addClass('Active');
  });
  
  //Header Slider
  var $HomeSliderNo = $('.HeaderSliderCount');
  var $HomeslickElement = $('.HeaderSlider');

  $HomeslickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $HomeSliderNo.html(i);
  });

  $('.HeaderSlider').slick({
    // dots: true,
    arrows: true,
    autoplay: true,
    fade: true,
    lazyLoad: 'ondemand',
    cssEase: 'linear',
    adaptiveHeight: true
  });

  //Search Box
  function SearchField(){
    const SearchItem = $('.SearchItem');
    $(document).mouseup(e => {
      if (!SearchItem.is(e.target) && SearchItem.has(e.target).length === 0){
        SearchItem.removeClass('SearchItem_Active');
      }
     });

    $('.SearchHam').on('click', (e) => {
      e.preventDefault();
      SearchItem.toggleClass('SearchItem_Active');
    });
  }
  SearchField();

  //Home tabs Slider 
  let dotTitles = []
  $('.TabsSlider').each(function(i) {   
    // console.log("this is working",i)  
    dotTitles.push($('#slide'+String(i+1)).data('title'));
  });

  const paging = function(slick,index) {  
    return '<span>' + dotTitles[index] + '</span>';
  }

  $("#HomeTabsSlider").slick({    
    dots: true,    
    customPaging: paging,    
    arrows: false,    
    slidesToShow: 1,    
    fade: true,    
    slidesToScroll: 1,    
    appendDots: $("#carouselPager")
  });

  // Product Faq
  $('.accordion').find('.accordion__title').click(function(){
    // Adds active class
    $(this).toggleClass('active');
    // Expand or collapse this panel
    $(this).next().slideToggle('fast');
    // Hide the other panels
    $('.accordion__content').not($(this).next()).slideUp('fast');
    // Removes active class from other titles
    $('.accordion__title').not($(this)).removeClass('active');    
  });

  //Home Inspirationalider
  $('.HomeInspirationalSlider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.InspirationalThumbSlider',
    autoplay: true
  });

  $('.InspirationalThumbSlider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.HomeInspirationalSlider',
    dots: false,
    centerMode: true,
    autoplay: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
        slidesToShow: 1,
        centerMode: false
        }
      },
    ]
  });

  //Blog Card Slider
  $('.BlogCardSlider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    // autoplay: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 2
        }
      },
      {
        breakpoint: 638,
        settings: {
        slidesToShow: 1,
        }
      },
    ]
  });

  //Experience center Tab
  $('.ExperienceCenterThumbSlider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.ExperienceCenterContentSlider',
    dots: false,
    // centerMode: true,
    // autoplay: true,
    focusOnSelect: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      },
    ]
  });

  $('.ExperienceCenterContentSlider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.ExperienceCenterThumbSlider',
    // autoplay: true
  });

  //Page Inspirationaider
  $('.MainInspirationThumbSlider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.MainInspirationContentSlider',
    dots: false,
    centerMode: true,
    // autoplay: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      },
    ]
  });

  $('.MainInspirationContentSlider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.MainInspirationThumbSlider',
    // autoplay: true
    adaptiveHeight: true
  });

  //Page Inspirationaider
  $('.HexagonalColorPalettes').slick({
    slidesToShow: 9,
    slidesToScroll: 9,
    arrows: true,
    dots: false,
    // autoplay: true,
    // focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 5,
        slidesToScroll: 5
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
    ]
  });

  // $('.ColorPaletteRelatedProduct').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   fade: true,
  //   asNavFor: '.HexagonalColorPalettes',
  //   // autoplay: true
  // });
  
  //Inspirationaider Magnific popup
  $('.ImageGalleryPopup').each(function() {
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300, 
        opener: function(element) {
          return element.find('img');
        }
      }
    });
  });

  //Trending Card Slider
  $(".TrendingCardSlider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    // autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      },
    ]
  });

  //Page Inspirationaider
  $('.CertificateLogos').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: true,
    autoplay: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      },
    ]
  });

   // ProductGallery
  $('.ProductSliderGallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.ProductGalleryThumbnail',
    autoplay: false
  });
  $('.ProductGalleryThumbnail').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.ProductSliderGallery',
    dots: false,
    centerMode: false,
    autoplay: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          centerMode: true
        }
      },
    ]
  });

  // World By Merino Inspirational Slider
  $('.WorldByMerinoSlider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
         breakpoint: 400,
         settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
         }
      }]
  });

  //Enquiry Form
 
   // Lazy Load
  // var myLazyLoad = new LazyLoad({
  //     elements_selector: ".lazy",
  //     load_delay: 700
  // });

  // Product dropdown tabs
  function dropdownTabs(){
    // $(".TableTab").hide();
    // $("#table1").show();

    $("#TabSelect").change(function(){
      var dropdownValue = $("#TabSelect").val();
      console.log("Val:", dropdownValue);
      $(".TableTab").hide();
      $("#" + "table" + dropdownValue).fadeIn(800);
    });
  }
  dropdownTabs();

  //Verticle Tab
  function verticleTab() {
    $(".tab_content").hide();
    $(".tab_content:first").show();
    /* if in tab mode */
    $("ul.tabs li").click(function() {
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();    
    
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
      /*$(".tabs").css("margin-top", function(){ 
       return ($(".tab_container").outerHeight() - $(".tabs").outerHeight() ) / 2;
      });*/
    });
    $(".tab_container").css("min-height", function(){ 
      return $(".tabs").outerHeight();
      console.log("tabs outerheight", $(".tabs").outerHeight());
    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
    
      $(".tab_drawer_heading").removeClass("d_active");
        $(this).addClass("d_active");
    
      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
  }
  verticleTab();
  
  
  //--- Rotate image on click --//
  // $(".RotateOnClick").on('click', function(e){
  //   e.preventDefault();
  //   $("#ProductDetails").toggleClass('Vertical');
  // });

   //-- Himanshu Rotate Image --//
  $(".RotateProductImage").on('click', function(e){
    e.preventDefault();
    $("#ProductDetails").toggleClass('Vertical');
  });
  
  //Rotate Image function
  var Page_Height = $(document).height();
  // console.log("Page_Height", Page_Height);
  var WindowWidth = $( window ).width();
  // console.log("window_width", WindowWidth);
  var RotateActiveClass;
  // console.log("Rotate Active Class", RotateActiveClass);
  function RotateImg(){
    $(".RotateProductImage").click(function(e){
      e.preventDefault();
      $(".ProductDetailsSection").toggleClass('ProductImgRotate_Active');
      RotateActiveClass = $(".ProductDetailsSection").hasClass("ProductImgRotate_Active");
      // console.log("Rotate Active Class", RotateActiveClass);
      $(".ProductImgRotate_Active .ProductImageOverlay").css("height", Page_Height);
      if (WindowWidth < 768 || RotateActiveClass){
        $(".ProductLeftSide").trigger("sticky_kit:detach");
      } else{
        $(".ProductLeftSide").stick_in_parent({
          offset_top: 20
        });
      }

    });
  }
  RotateImg();

  //Show Full Image
  $(".ShowFullImage .Button").click(function(){
    var ProductLeftSide = $(".ProductLeftSide");
    (ProductLeftSide).toggleClass('ShowfullImageActive');
    if(ProductLeftSide.hasClass("ShowfullImageActive")) {
      $(".ShowfullImageActive .ShowFullImage .Button").html("Show Half Image");
    } else{
      $(".ShowFullImage .Button").html("Show Full Image");
    }
    
  })

  if (WindowWidth < 768){
    $(".StickySection").trigger("sticky_kit:detach");
  } else{
    $(".StickySection").stick_in_parent({
      offset_top: 20,
      recalc_every: 10
    });
  }

  function SubMenu_sticky(){
    $(".SubMenuBarSection").stick_in_parent({
      // offset_top: HeaderHeight
    });
  }
  SubMenu_sticky();

  //FilterMenu Sticky
  function FilterMenuStick(){
    var FilterMenu = $(".FilterMenuSection").offset() - $(window).scrollTop();
    // console.log("FilterMenu", FilterMenu);
    if (FilterMenu == 45){
      $(".SubMenuBarSection").trigger("sticky_kit:detach");
    }

    // $(".FilterMenuSection").stick_in_parent({
    //   // offset_top: HeaderHeight - 15
    // });
    if (WindowWidth < 768){
        $(".FilterMenuSection").trigger("sticky_kit:detach");
    } else{
      $(".FilterMenuSection").stick_in_parent({
        // offset_top: HeaderHeight - 15
      });
    }

  }
  FilterMenuStick();

//Mobile View filter
function FilterMobileview(){
  var ProductGallery = $("#ProductGallery");
  // console.log("Product_Gallery", ProductGallery.length);
  if (WindowWidth < 768 && ProductGallery.length){
    $(window).scroll(function(){
      
        if ($('#ProductGallery').isOnScreen()) {
            // console.log("in viewport!");
            $(".FilterMobileviewCol").fadeIn();
        } else {
            $(".FilterMobileviewCol").fadeOut();
            $(".FilterMobileviewCol .FilterMenuSection").fadeOut("slow");
        }      
    });
  }

  $.fn.isOnScreen = function(){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height() - 40;
    
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  };
  
  // var ProductMainContainer = $(".ProductMainContainer").offset().top - $(window).scrollTop();
  // console.log("ProductMainContainer", ProductMainContainer);

  $(".FilterMinuMobile").click(function(){
    $(".FilterMobileviewCol .FilterMenuSection").slideToggle("fast");
  });
  if (WindowWidth < 768){
    $(".FilterMenuSection form .Button").click(function(){
      $(".FilterMobileviewCol .FilterMenuSection").slideToggle("fast");
    });
  }
}
FilterMobileview();
$('.CloseFilterButton').click(function(event) {
  event.preventDefault();
  $(".FilterMobileviewCol .FilterMenuSection").slideToggle("fast");
})

  // //Sub Menu Bar Active class and smooth scroll
  // function SubMenuSmoothScroll(){
  //   var SubMenuHeight = $('.SubMenuBarSection').outerHeight();
  //   var TotlMenuHeight = HeaderHeight + SubMenuHeight;
  //   $(".SubMenuContainer a").on('click', function(event) {
  //     if (this.hash !== "") {
  //         event.preventDefault();
  //         var hash = this.hash;                         
  //         $('html, body').animate({     
  //             scrollTop: $(hash).offset().top-HeaderHeight
  //             // scrollTop: $(hash).offset().top
  //         }, 100, 'swing', function() {
  //             return false;  
  //         });   
  //     }
  //     // $(".SubMenuContainer a.is_Active").removeClass("is_Active");   
  //     // $(this).addClass("is_Active");  
  //   });
  
  //   $(document).on("scroll", function(event){
  //     var scrollPos = $(document).scrollTop();
  //     $(".SubMenuContainer a").each(function(){
  //         var currLink = $(this);
  //         var refElement = $(currLink.attr("href"));
  //         // if(refElement.position().top-TotlMenuHeight <= scrollPos && refElement.position().top-TotlMenuHeight + refElement.height() > scrollPos) {
  //         if(refElement.position() <= scrollPos && refElement.position() + refElement.height() > scrollPos) {
  //             $(".SubMenuContainer li a").removeClass("is_Active");
  //             currLink.addClass("is_Active");
  //         }
  //         else{
  //             currLink.removeClass("is_Active");
  //         }
  //     });
  //   });
  // }
  // SubMenuSmoothScroll();

  //Multi Select
  $('#Location').multiselect({
    columns: 1,
    placeholder: 'Select Location',
  });

  // Custom Select
  function Custome_Select_Dropdown(){
    $('.CustomSelect').each(function () {

      var $this = $(this),
          numberOfOptions = $(this).children('option').length;

      $this.addClass('s-hidden');

      $this.wrap('<div class="CustomizedSelect"></div>');

      $this.after('<div class="styledSelect"></div>');

      var $styledSelect = $this.next('div.styledSelect');
      $styledSelect.text($this.children('option').eq(0).text());
      var $list = $('<ul />', {
          'class': 'options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
              text: $this.children('option').eq(i).text(),
              rel: $this.children('option').eq(i).val()
          }).appendTo($list);
      }
      var $listItems = $list.children('li');
      $styledSelect.click(function (e) {
          e.stopPropagation();
          $('div.styledSelect.active').each(function () {
              $(this).removeClass('active').next('ul.options').hide();
          });
          $(this).toggleClass('active').next('ul.options').toggle();
      });
      $listItems.click(function (e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.hide();
          /* alert($this.val()); Uncomment this for demonstration! */
      });
      $(document).click(function () {
          $styledSelect.removeClass('active');
          $list.fadeOut();
      });

    });
  }
  Custome_Select_Dropdown();

  // About us video section (Sahil)
  $('.popup-youtube').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 100,
    preloader: true,
    fixedContentPos: true
  });

  // Enquiry form popup
  $('.EnquireBtn').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 100,
    preloader: true,
    fixedContentPos: true
  });

  // Social Media Share popup
  $('.ShareBtn').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 100,
    preloader: true,
    fixedContentPos: true
  });

  // Email form popup
  $('.EmailBtn').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 100,
    preloader: true,
    fixedContentPos: true
  });
 
 // Sign up form pop up
  $('.signUpBtn').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 100,
    preloader: true,
    fixedContentPos: true
  });


  //Upload Image Imagino
  $(".TabContents").each(function(index){
    //   console.log("TabContents", index);
    var TabContents = $(this);
    // console.log("TabContents", TabContents);
    var fileuploadBtn = $(this).find('.fileuploadBtn');
    var ImageContainer = $(this).find('.ImageContainer');
    var UploadedImgWrap = $(this).find('.UploadedImgWrap');
    var MainImage = $(this).find('.MainImage');
    // console.log("UploadedImgWrap", UploadedImgWrap);
    var ShareImaginoBtn = $(this).find('.ShareListBtn');
    var DownloadBtn = $(this).find('.DownloadList');
    var EmailImaginoBtn = $(this).find('.EmailListBtn');
    var BottomIconWrap = $(this).find('.BottomIconWrap');
    var getCanvas;
    var currentTime;
    var canvasName;

    var MainImageSrc = (MainImage).attr("src");
    // console.log("MainImageSrc", MainImageSrc);
    var VisualRoomTabsContainer = $(".VisualRoomTabsContainer");
    var scrollPos;
    $(".BottomIconWrap a.ShareListBtn, .BottomIconWrap a.EmailListBtn").on("click", function(e){
      e.preventDefault();
    });
    (fileuploadBtn).fileupload({
      dataType: 'json',
      type: 'POST',

      // url: '//jquery-file-upload.appspot.com/',
      url: (`${siteurl}/virtual-room/upload.php`),
      // url: 'http://merino.cobold.xyz/wp-content/themes/merino/virtual-room/upload.php',
      autoUpload: false,
      acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
      maxFileSize: 1048576, //1MB
      disableImageResize: /Android(?!.*Chrome)|Opera/ 
      .test(window.navigator.userAgent),
      // previewMaxWidth: 50,
      // previewMaxHeight: 50,
      disableImageResize: false,
      previewMinWidth: 400,
      previewMinHeight: 400,
      imageMaxWidth: 800,
      imageMaxHeight: 800,
      imageCrop: true,
      previewCrop: true,
      dropZone: $('#dropzone'),
      add: function (e, data){
        // console.log("add data", data);
        (MainImage).hide();
        data.context = $('<img class="UploadedImage">')
          .appendTo(UploadedImgWrap);
          $('<div class="ImageCanvas" style="display: none">').appendTo(ImageContainer);
        data.Preloader = $('<div class="Uploading_Preloader">')
        .append($('<div class="spinner">'))
        .append($('<h4>Uploading...</h4>'))
        .appendTo(ImageContainer);
          var MyThis = $(this);
          // console.log("MyThis", MyThis);
        data.submit();
      },
      
      done: function(e, data){
        e.preventDefault();
        console.log("data result", data.result.files[0]);
        (UploadedImgWrap).addClass("uploaded");
        data.context.prop("src", data.result.files[0].url);
        // console.log("ImageCanvas", ImageCanvas);
        $('.Uploading_Preloader').fadeOut();
        $('.Uploading_Preloader').remove();
       
        html2canvas(UploadedImgWrap, {
          // logging: true,
          // letterRendering: 1,
          allowTaint: true,
          useCORS: true,
          onrendered: function (canvas){
            $('.ImageCanvas').append(canvas);
             getCanvas = canvas;
             
             //upload Canvas Image
             setTimeout(function(){
                var imageData = getCanvas.toDataURL("image/jpg");
                $.ajax({
                  type:'POST',
                  url: (`${siteurl}/virtual-room/uploadCanvas.php`),
                  // headers: {
                  //     'Content-Type': 'application/x-www-form-urlencoded'
                  // },
                  data: {imageData: imageData},
                  cache:false,
                  crossDomain: true,
                  success:function(data){
                      console.log("success");
                      console.log(data);
                      canvasName = data;
                      console.log("canvasName", canvasName);
                  },
                  error: function(data){
                      console.log("error");
                      console.log(data);
                  }
                });
              }, 1000);
          },
        });
        //Download Image
        (DownloadBtn).on('click', function(){
          // console.log("getCanvas clicked :", getCanvas);
          var imgageData = getCanvas.toDataURL("image/jpg");
          var newData = imgageData.replace(/^data:image\/jpg/, "data:application/octet-stream");
          (DownloadBtn).attr("download", "imagino-virtual-room.jpg").attr("href", newData);
          // console.log("newData :", newData);
        });

        //Share Image
        (ShareImaginoBtn).on("click", function(e){
          e.preventDefault();
          var imageData = getCanvas.toDataURL("image/jpg");
          var newData = imageData.replace(/^data:image\/jpg/, "data:application/octet-stream");
          var imgInnerImage = (BottomIconWrap).find('.ShareImaginoModal_InnerImage .InnerImage');
          var ShareImageLink = (`${siteurl}/imagino-uploads/imagino-${canvasName}.jpg`);
          console.log("ShareImageLink", ShareImageLink);
          (imgInnerImage).attr("src", ShareImageLink);
          $('.ImaginoOverlay').fadeIn('slow');
          setTimeout(function(){
            $('.ShareImaginoModal').fadeIn('slow');
          }, 300);
          $('.CrossBtn, .ImaginoOverlay').on("click", function(){
            $('.ShareImaginoModal').fadeOut('slow');
            $('.ImaginoOverlay').fadeOut('slow');
          });
          var facebookShare = 'https://www.facebook.com/sharer/sharer.php?u='+ShareImageLink;
          $('#virtual_facebook').attr("href", facebookShare);
          var whatsAppShare = 'https://api.whatsapp.com/send?text='+ShareImageLink;
          $('#virtual_whatsapp').attr("href", whatsAppShare);
          console.log('whatsAppShare', whatsAppShare);
          // console.log('ShareBtn', imgInnerImage.attr("src"));
        });

        //Email Image
        (EmailImaginoBtn).on("click", function(e){
          e.preventDefault();
          console.log("Email Time", canvasName);
          var imageData = getCanvas.toDataURL("image/jpg");
          var newData = imageData.replace(/^data:image\/jpg/, "data:application/octet-stream");
          var imaginoFormTextarea = (BottomIconWrap).find('.EmailImaginoModal #linktoimage');
          (imaginoFormTextarea).val(`${siteurl}/imagino-uploads/imagino-${canvasName}.jpg`);
          $('.ImaginoEmailOverlay').fadeIn('slow');
          setTimeout(function(){
            $('.EmailImaginoModal').fadeIn('slow');
          }, 300);
          $('.CrossBtn, .ImaginoEmailOverlay').on("click", function(){
            $('.EmailImaginoModal').fadeOut('slow');
            $('.ImaginoEmailOverlay').fadeOut('slow');
          })
          console.log('EmailBtn', imaginoFormTextarea.val());
        });
        
        //Reset Image upload
        (BottomIconWrap).find('.fileuploadBtn').hide();
        $('<button class="Reset">Reset</button>').appendTo((BottomIconWrap).find('.FileUpload .ActionList'));
        (BottomIconWrap).find('.Reset').on("click", function(){
          console.log("Clicked Submit");
          (ImageContainer).find(".ImageCanvas").remove();
          (UploadedImgWrap).removeClass('uploaded');
          (UploadedImgWrap).find(".UploadedImage").remove();
          (MainImage).show();
          (BottomIconWrap).find('.fileuploadBtn').show();
          $(this).remove();
          // console.log("MainImageSrc", MainImageSrc);
          // (DownloadBtn).attr("download", "imagino-virtual-room.jpg").attr("href", MainImageSrc);
        });
      }
    });
      
  }); // End Upload Image 

  // Year Timeline
  var timelines = $('.cd-horizontal-timeline'),
    eventsMinDistance = 150;

  (timelines.length > 0) && initTimeline(timelines);

  function initTimeline(timelines) {
    timelines.each(function(){
      var timeline = $(this),
        timelineComponents = {};
      //cache timeline components 
      timelineComponents['timelineWrapper'] = timeline.find('.events-wrapper');
      timelineComponents['eventsWrapper'] = timelineComponents['timelineWrapper'].children('.events');
      timelineComponents['fillingLine'] = timelineComponents['eventsWrapper'].children('.filling-line');
      timelineComponents['timelineEvents'] = timelineComponents['eventsWrapper'].find('a');
      timelineComponents['timelineDates'] = parseDate(timelineComponents['timelineEvents']);
      timelineComponents['eventsMinLapse'] = minLapse(timelineComponents['timelineDates']);
      timelineComponents['timelineNavigation'] = timeline.find('.cd-timeline-navigation');
      timelineComponents['eventsContent'] = timeline.children('.events-content');

      //assign a left postion to the single events along the timeline
      setDatePosition(timelineComponents, eventsMinDistance);
      //assign a width to the timeline
      var timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);
      //the timeline has been initialize - show it
      timeline.addClass('loaded');

      //detect click on the next arrow
      timelineComponents['timelineNavigation'].on('click', '.next', function(event){
        event.preventDefault();
        updateSlide(timelineComponents, timelineTotWidth, 'next');
      });
      //detect click on the prev arrow
      timelineComponents['timelineNavigation'].on('click', '.prev', function(event){
        event.preventDefault();
        updateSlide(timelineComponents, timelineTotWidth, 'prev');
      });
      //detect click on the a single event - show new event content
      timelineComponents['eventsWrapper'].on('click', 'a', function(event){
        event.preventDefault();
        timelineComponents['timelineEvents'].removeClass('selected');
        $(this).addClass('selected');
        updateOlderEvents($(this));
        updateFilling($(this), timelineComponents['fillingLine'], timelineTotWidth);
        updateVisibleContent($(this), timelineComponents['eventsContent']);
      });

      //on swipe, show next/prev event content
      timelineComponents['eventsContent'].on('swipeleft', function(){
        var mq = checkMQ();
        ( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'next');
      });
      timelineComponents['eventsContent'].on('swiperight', function(){
        var mq = checkMQ();
        ( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'prev');
      });

      //keyboard navigation
      $(document).keyup(function(event){
        if(event.which=='37' && elementInViewport(timeline.get(0)) ) {
          showNewContent(timelineComponents, timelineTotWidth, 'prev');
        } else if( event.which=='39' && elementInViewport(timeline.get(0))) {
          showNewContent(timelineComponents, timelineTotWidth, 'next');
        }
      });
    });
  }

  function updateSlide(timelineComponents, timelineTotWidth, string) {
    //retrieve translateX value of timelineComponents['eventsWrapper']
    var translateValue = getTranslateValue(timelineComponents['eventsWrapper']),
      wrapperWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', ''));
    //translate the timeline to the left('next')/right('prev') 
    (string == 'next') 
      ? translateTimeline(timelineComponents, translateValue - wrapperWidth + eventsMinDistance, wrapperWidth - timelineTotWidth)
      : translateTimeline(timelineComponents, translateValue + wrapperWidth - eventsMinDistance);
  }

  function showNewContent(timelineComponents, timelineTotWidth, string) {
    //go from one event to the next/previous one
    var visibleContent =  timelineComponents['eventsContent'].find('.selected'),
      newContent = ( string == 'next' ) ? visibleContent.next() : visibleContent.prev();

    if ( newContent.length > 0 ) { //if there's a next/prev event - show it
      var selectedDate = timelineComponents['eventsWrapper'].find('.selected'),
        newEvent = ( string == 'next' ) ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');
      
      updateFilling(newEvent, timelineComponents['fillingLine'], timelineTotWidth);
      updateVisibleContent(newEvent, timelineComponents['eventsContent']);
      newEvent.addClass('selected');
      selectedDate.removeClass('selected');
      updateOlderEvents(newEvent);
      updateTimelinePosition(string, newEvent, timelineComponents, timelineTotWidth);
    }
  }

  function updateTimelinePosition(string, event, timelineComponents, timelineTotWidth) {
    //translate timeline to the left/right according to the position of the selected event
    var eventStyle = window.getComputedStyle(event.get(0), null),
      eventLeft = Number(eventStyle.getPropertyValue("left").replace('px', '')),
      timelineWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', '')),
      timelineTotWidth = Number(timelineComponents['eventsWrapper'].css('width').replace('px', ''));
    var timelineTranslate = getTranslateValue(timelineComponents['eventsWrapper']);

        if( (string == 'next' && eventLeft > timelineWidth - timelineTranslate) || (string == 'prev' && eventLeft < - timelineTranslate) ) {
          translateTimeline(timelineComponents, - eventLeft + timelineWidth/2, timelineWidth - timelineTotWidth);
        }
  }

  function translateTimeline(timelineComponents, value, totWidth) {
    var eventsWrapper = timelineComponents['eventsWrapper'].get(0);
    value = (value > 0) ? 0 : value; //only negative translate value
    value = ( !(typeof totWidth === 'undefined') &&  value < totWidth ) ? totWidth : value; //do not translate more than timeline width
    setTransformValue(eventsWrapper, 'translateX', value+'px');
    //update navigation arrows visibility
    (value == 0 ) ? timelineComponents['timelineNavigation'].find('.prev').addClass('inactive') : timelineComponents['timelineNavigation'].find('.prev').removeClass('inactive');
    (value == totWidth ) ? timelineComponents['timelineNavigation'].find('.next').addClass('inactive') : timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
  }

  function updateFilling(selectedEvent, filling, totWidth) {
    //change .filling-line length according to the selected event
    var eventStyle = window.getComputedStyle(selectedEvent.get(0), null),
      eventLeft = eventStyle.getPropertyValue("left"),
      eventWidth = eventStyle.getPropertyValue("width");
    eventLeft = Number(eventLeft.replace('px', '')) + Number(eventWidth.replace('px', ''))/2;
    var scaleValue = eventLeft/totWidth;
    setTransformValue(filling.get(0), 'scaleX', scaleValue);
  }

  function setDatePosition(timelineComponents, min) {
    for (var i = 0; i < timelineComponents['timelineDates'].length; i++) { 
        var distance = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][i]),
          distanceNorm = Math.round(distance/timelineComponents['eventsMinLapse']+1);
        timelineComponents['timelineEvents'].eq(i).css('left', distanceNorm*min+'px');
    }
  }

  function setTimelineWidth(timelineComponents, width) {
    var timeSpan = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][timelineComponents['timelineDates'].length-1]),
      timeSpanNorm = timeSpan/timelineComponents['eventsMinLapse'],
      timeSpanNorm = Math.round(timeSpanNorm) + 3,
      totalWidth = timeSpanNorm*width;
    timelineComponents['eventsWrapper'].css('width', totalWidth+'px');
    updateFilling(timelineComponents['timelineEvents'].eq(0), timelineComponents['fillingLine'], totalWidth);
  
    return totalWidth;
  }

  function updateVisibleContent(event, eventsContent) {
    var eventDate = event.data('date'),
      visibleContent = eventsContent.find('.selected'),
      selectedContent = eventsContent.find('[data-date="'+ eventDate +'"]'),
      selectedContentHeight = selectedContent.height();

    if (selectedContent.index() > visibleContent.index()) {
      var classEnetering = 'selected enter-right',
        classLeaving = 'leave-left';
    } else {
      var classEnetering = 'selected enter-left',
        classLeaving = 'leave-right';
    }

    selectedContent.attr('class', classEnetering);
    visibleContent.attr('class', classLeaving).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
      visibleContent.removeClass('leave-right leave-left');
      selectedContent.removeClass('enter-left enter-right');
    });
    eventsContent.css('height', selectedContentHeight+'px');
  }

  function updateOlderEvents(event) {
    event.parent('li').prevAll('li').children('a').addClass('older-event').end().end().nextAll('li').children('a').removeClass('older-event');
  }

  function getTranslateValue(timeline) {
    var timelineStyle = window.getComputedStyle(timeline.get(0), null),
      timelineTranslate = timelineStyle.getPropertyValue("-webkit-transform") ||
            timelineStyle.getPropertyValue("-moz-transform") ||
            timelineStyle.getPropertyValue("-ms-transform") ||
            timelineStyle.getPropertyValue("-o-transform") ||
            timelineStyle.getPropertyValue("transform");

        if( timelineTranslate.indexOf('(') >=0 ) {
          var timelineTranslate = timelineTranslate.split('(')[1];
        timelineTranslate = timelineTranslate.split(')')[0];
        timelineTranslate = timelineTranslate.split(',');
        var translateValue = timelineTranslate[4];
        } else {
          var translateValue = 0;
        }

        return Number(translateValue);
  }

  function setTransformValue(element, property, value) {
    element.style["-webkit-transform"] = property+"("+value+")";
    element.style["-moz-transform"] = property+"("+value+")";
    element.style["-ms-transform"] = property+"("+value+")";
    element.style["-o-transform"] = property+"("+value+")";
    element.style["transform"] = property+"("+value+")";
  }

  //based on http://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
  function parseDate(events) {
    var dateArrays = [];
    events.each(function(){
      var dateComp = $(this).data('date').split('/'),
        newDate = new Date(dateComp[2], dateComp[1]-1, dateComp[0]);
      dateArrays.push(newDate);
    });
      return dateArrays;
  }

  function parseDate2(events) {
    var dateArrays = [];
    events.each(function(){
      var singleDate = $(this),
        dateComp = singleDate.data('date').split('T');
      if( dateComp.length > 1 ) { //both DD/MM/YEAR and time are provided
        var dayComp = dateComp[0].split('/'),
          timeComp = dateComp[1].split(':');
      } else if( dateComp[0].indexOf(':') >=0 ) { //only time is provide
        var dayComp = ["2000", "0", "0"],
          timeComp = dateComp[0].split(':');
      } else { //only DD/MM/YEAR
        var dayComp = dateComp[0].split('/'),
          timeComp = ["0", "0"];
      }
      var newDate = new Date(dayComp[2], dayComp[1]-1, dayComp[0], timeComp[0], timeComp[1]);
      dateArrays.push(newDate);
    });
      return dateArrays;
  }

  function daydiff(first, second) {
      return Math.round((second-first));
  }

  function minLapse(dates) {
    //determine the minimum distance among events
    var dateDistances = [];
    for (var i = 1; i < dates.length; i++) { 
        var distance = daydiff(dates[i-1], dates[i]);
        dateDistances.push(distance);
    }
    return Math.min.apply(null, dateDistances);
  }

  /*
    How to tell if a DOM element is visible in the current viewport?
    http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
  */
  function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
  }

  function checkMQ() {
    //check if mobile or desktop device
    return window.getComputedStyle(document.querySelector('.cd-horizontal-timeline'), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "");
  }


});//--- End document.ready


//Mobile Menu
  var menu123 = new MmenuLight( document.querySelector( '#menu' ), {});
  menu123.enable( 'all' ); // '(max-width: 900px)'
  menu123.offcanvas({});

  //  Open the menu.
   $('a#MenuToggle').click(function(event) {
    menu123.open();
    event.preventDefault();
    event.stopPropagation();
   })

  $('.lrm-login.mobile').off().on('click', function() {
    menu123.close();
    $('.lrm-main').addClass('is-visible');
    $('.lrm-signin-section').addClass('is-selected');
    $('.lrm-switch-to--login').addClass('selected');
  });

 $(document).ready(function() {
    var doc = document.documentElement;
    var HeadspaceWindow = window;
    var prevScroll = HeadspaceWindow.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;
    var MainHeader = document.getElementById('header');

    var checkScroll = function() {
      curScroll = HeadspaceWindow.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) { 
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }
      
      prevScroll = curScroll;
    };

    var toggleHeader = function(direction, curScroll) {
      if (direction === 2 && curScroll > 150) { 
        MainHeader.classList.add('hide');
        prevDirection = direction;
      }
      else if (direction === 1) {
          MainHeader.classList.remove('hide');
          prevDirection = direction;
      
      }
    };
    window.addEventListener('scroll', checkScroll);
    // var tabber = new HashTabber();
    // tabber.run();
 })
 
  
  // Wish List Icon animated while adding item
  function AddToWishList() {
    // var counterNumber = 0;
  //   $(".AddToWishlist").click(function () {
  //     // var counter = $("#Count");
  //     // counterNumber +=1;
  //     // // console.log('counterNumber', counterNumber);
  //     // counter.html(counterNumber);
  //   //   var wishlist_icon = $(".WishlistIcon");
  //   //   wishlist_icon.addClass("addedWishList");
  //   //   setTimeout(function () {
  //   //   wishlist_icon.removeClass("addedWishList");
  //   // }, 1000);
  // });
    
  var removeListIcon = $(".removeFromList");
    var i;
    $('.cwl-wishlist ul>li').each(function(){
      $(this).find(".removeFromList").click(function(){
        var ParentList = $(this).parents('.cwl-wishlist ul>li');
        ParentList.fadeOut();
      })
    });


  // $('.header .btn_wishlist:nth-of-type(2)').click(function(){
  //   var removeWishlist = confirm("Do you want to Remove all items From Wishlist?");
  //   if(removeWishlist){
  //   $(".cwl-wishlist .inner_wishlist").css("display","none");
  // }
  // else{
  //   $(".cwl-wishlist .inner_wishlist").css("display","none");
  // }
$('.header .btn_wishlist:nth-of-type(2)').click(function(){
confirm("Do you want to Remove all items From Wishlist?");
$(".cwl-wishlist .inner_wishlist").hide(500);
});

  // });

    // var wishListWrap = $(".cwl-wishlist .list_inner ul");
    // var wishlistHeader = $(".header");
    // if(wishListWrap){
    //   wishlistHeader.addClass("show");
    // }
    // else{
    //    wishlistHeader.removeClass("hide");
    // }
    

    $(".WishlistIcon").on("click", function() {
      $(".cwl-wishlist").fadeToggle( "fast");
    });
    $("#hideList").click(function() {
      // alert("hello");
      $(".cwl-wishlist").css("display","none");
  });
}
  AddToWishList();

   

$('#choose_slelect').on('change', function () {
  if (this.value == 'Upload Your Image') {
    $(".UploadType").show();
  }
  else{
    $(".UploadType").hide();
  }
  if (this.value == 'Select From Range') {
    $("#select_range").show();
  }
  else{
    $("#select_range").hide();
  }

});


$(document).ready(function() {

  $('#select_country').on('change', function () {
    if (this.value == 'India') {
      $("#select_state").show();
      $("#selected_country").hide();
    }
    else{
      $("#select_state").hide();
      $('#selected_country').show();
    }
  });

  var coutry = $('#select_country').val();
  if(coutry == 'India'){
    $("#select_state").show();
    $('#selected_country').hide();
  }

  $('#mobile_field[max]:not([max=""])').on('input', function(ev) {
      var $this = $(this);
      var maxlength = $this.attr('max').length;
      var value = $this.val();
      if (value && value.length >= maxlength) {
        $this.val(value.substr(0, maxlength));
      }
  });
  
  $("#mobile_field").on("focus", function() {
      $(this).on("keydown", function(event) {
          if (event.keyCode === 38 || event.keyCode === 40) {
              event.preventDefault();
          }
      });
  });

    var userName = $('.numberField');

    userName.on('input', function(e) {
      var newValue = this.value.replace(new RegExp(/[^\d]/,'ig'), "");
      this.value = newValue;
    });


  $('.StateClass').find('p').remove();


  $('.MECState').on('change', function(){
    
    var ChossenState = $(this).val();

    // console.log(ChossenState, "state selected");

    if(ChossenState == "Maharashtra"){
      $('.MECCity').val("Mumbai");
    }
    if(ChossenState == "Delhi") {
      $('.MECCity').val("New Delhi");
    }
    if(ChossenState == "Kerala"){
      $('.MECCity').val("Kochi");
    }
  });

  // Quick Query
  $('#QuickQuery_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#QuickQuery_select_state").show();
      $("#QuickQuery_selected_country").hide();
    }
    else{
      $("#QuickQuery_select_state").hide();
      $('#QuickQuery_selected_country').show();
    }
  });

  var coutry = $('#QuickQuery_select_country').val();
  if(coutry == 'India'){
    $("#QuickQuery_select_state").show();
    $('#QuickQuery_selected_country').hide();
  }
  // End Quick Query

  // Contact Us
  $('#contact_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#contact_select_state").show();
      $("#contact_selected_country").hide();
    }
    else{
      $("#contact_select_state").hide();
      $('#contact_selected_country').show();
    }
  });

  var coutry = $('#contact_select_country').val();
  if(coutry == 'India'){
    $("#contact_select_state").show();
    $('#contact_selected_country').hide();
  }
  // End Contact Us

  // Download SKU Image
  $('#DownloadSKU_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#DownloadSKU_select_state").show();
      $("#DownloadSKU_selected_country").hide();
    }
    else{
      $("#DownloadSKU_select_state").hide();
      $('#DownloadSKU_selected_country').show();
    }
  });

  var coutry = $('#DownloadSKU_select_country').val();
  if(coutry == 'India'){
    $("#DownloadSKU_select_state").show();
    $('#DownloadSKU_selected_country').hide();
  }
  // End Download SKU Image

  // E-cataloque
  $('#Ecataloque_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#Ecataloque_select_state").show();
      $("#Ecataloque_selected_country").hide();
    }
    else{
      $("#Ecataloque_select_state").hide();
      $('#Ecataloque_selected_country').show();
    }
  });

  var coutry = $('#Ecataloque_select_country').val();
  if(coutry == 'India'){
    $("#Ecataloque_select_state").show();
    $('#Ecataloque_selected_country').hide();
  }
  // End E-cataloque

   // Email SKU
  $('#EmailSKU_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#EmailSKU_select_state").show();
      $("#EmailSKU_selected_country").hide();
    }
    else{
      $("#EmailSKU_select_state").hide();
      $('#EmailSKU_selected_country').show();
    }
  });

  var coutry = $('#EmailSKU_select_country').val();
  if(coutry == 'India'){
    $("#EmailSKU_select_state").show();
    $('#EmailSKU_selected_country').hide();
  }
  // End Email SKU

  // Enquire SKU
  $('#EnquireSKU_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#EnquireSKU_select_state").show();
      $("#EnquireSKU_selected_country").hide();
    }
    else{
      $("#EnquireSKU_select_state").hide();
      $('#EnquireSKU_selected_country').show();
    }
  });

  var coutry = $('#EnquireSKU_select_country').val();
  if(coutry == 'India'){
    $("#EnquireSKU_select_state").show();
    $('#EnquireSKU_selected_country').hide();
  }
  // End Enquire SKU

  // Imagino Step
  $('#ImaginoStep_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#ImaginoStep_select_state").show();
      $("#ImaginoStep_selected_country").hide();
    }
    else{
      $("#ImaginoStep_select_state").hide();
      $('#ImaginoStep_selected_country').show();
    }
  });

  var coutry = $('#ImaginoStep_select_country').val();
  if(coutry == 'India'){
    $("#ImaginoStep_select_state").show();
    $('#ImaginoStep_selected_country').hide();
  }
  // End Imagino Step

  // Imagino Virtual Room
  $('#ImaginoVRoom_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#ImaginoVRoom_select_state").show();
      $("#ImaginoVRoom_selected_country").hide();
    }
    else{
      $("#ImaginoVRoom_select_state").hide();
      $('#ImaginoVRoom_selected_country').show();
    }
  });

  var coutry = $('#ImaginoVRoom_select_country').val();
  if(coutry == 'India'){
    $("#ImaginoVRoom_select_state").show();
    $('#ImaginoVRoom_selected_country').hide();
  }
  // End Imagino Virtual Room

  // Wishlist
  $('#Wishlist_select_country').on('change', function () {
    if (this.value == 'India') {
      $("#Wishlist_select_state").show();
      $("#Wishlist_selected_country").hide();
    }
    else{
      $("#Wishlist_select_state").hide();
      $('#Wishlist_selected_country').show();
    }
  });

  var coutry = $('#Wishlist_select_country').val();
  if(coutry == 'India'){
    $("#Wishlist_select_state").show();
    $('#Wishlist_selected_country').hide();
  }
  // End Wishlist
  // matrix disclaimerLink form pop up
  $('.disclaimerLink').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      preloader: true,
      fixedContentPos: true
    });
  // end

  // Sign up form pop up
  $('.ECataloguePopup').magnificPopup({
      // type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      preloader: true,
      fixedContentPos: true,
  });

  $('.ECataloguePopup').on('mfpClose', function(e) {
      $('.PromptMessage').remove();
      $('.wpcf7-mail-sent-ok').remove();
      $('.wpcf7-validation-errors').remove();
  });

  $('.wpcf7-submit').click(function() {
      $('.wpcf7-submit').addClass('avoid-clicks');
  })
  document.addEventListener( 'wpcf7submit', function( event ) {
    $('.wpcf7-submit').removeClass('avoid-clicks');
  }, false );

  // SKUs disclaimer popup
  $('.DeclaimerBtn').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      preloader: true,
      fixedContentPos: true
    });
  // end

});
